module.exports = __webpack_public_path__ + "img/b_17.e313fc04.jpg";